<template>
  <section class="duty-content" style="background: #FFFFFF">
    <el-row :gutter="5">
      <el-col :span="10">
        <div class="duty-preview">
          <div class="duty-title">
            <i class="el-icon-chat-line-square" style="margin-left: 20px"></i>
            <span>联系我们</span>
          </div>
          <div class="content-block" :style="{'height':blockHeight+'px'}" style="overflow: auto">
            <div>
              <el-row :gutter="5" style="font-weight: 700;margin-top: 20px">
                <el-col :span="5">
                  <i style="font-size: 30px;margin-left: 20px;" class="el-icon-phone"></i>
                </el-col>
                <el-col :span="19">
                  <span style="font-size: 16px">服务热线: 0971-96868</span>
                </el-col>
              </el-row>
            </div>
            <el-row :gutter="5" style="font-weight: 700;margin-top: 20px">
              <el-col :span="5">
                <i style="font-size: 30px;margin-left: 20px;" class="el-icon-message"></i>
              </el-col>
              <el-col :span="19">
                <span style="font-size: 16px">联系邮箱: qh96868@126.com</span>
              </el-col>
            </el-row>
            <div>
              <el-row :gutter="5" style="font-weight: 700;margin-top: 20px">
                <el-col :span="5">
                  <i style="font-size: 30px;margin-left: 20px;" class="el-icon-s-custom"></i>
                </el-col>
                <el-col :span="19">
                  <span style="font-size: 16px">办公时间 周一至周五</span>
                  <div style="font-size: 16px;margin-top: 10px;">AM 09:00-12:00</div>
                  <div style="font-size: 16px;margin-top: 5px;">PM 14:00-17:00</div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="14">
        <img src="/static/ic_contact.jpg" style="width: 99%;"/>
      </el-col>
    </el-row>
  </section>
</template>
<script>
  export default {
    data () {
      return {
        blockHeight: (document.documentElement.clientHeight - 413)
      }
    },
    mounted () {

    },
    methods: {

    }
  }
</script>
<style>
  .duty-preview {

  }
  .duty-preview .duty-title {
    background: #0068BC;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    color: #FFFFFF;
    font-size: 22px;
    font-weight: 800;
  }
  .duty-content .content-block {
    background: #FFFFFF;
    padding: 5px;
  }
  .duty-content .content-list-item {
    margin-top: 10px;
    font-size: 13px;
    cursor: pointer;
    height: 18px;
    line-height: 18px;
  }
  .duty-content .content-list-item .content-title {
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    white-space:nowrap;
    height: 18px;
  }
  .duty-content .content-list-item .content-list-item-dot{
    margin-top: 7px;
    height: 4px;
    width: 4px;
    background: #0068BC;
  }
</style>



// WEBPACK FOOTER //
// src/components/portal/Contact.vue